import {ICondition, IRule, IRuleset} from "../../../index";
import {MutableRule} from "../mutable/rule/MutableRule";
import {MutableRuleset} from "../mutable/mutableRuleset";

interface IDerivedMutableParams {
    rule: IRule | MutableRule
    ruleset: IRuleset | MutableRuleset
    conditions: ICondition[]
}

type TType = 'group' | 'item'
